import { Controller } from '@hotwired/stimulus';

export default class PreventTurboScrollController extends Controller {
  connect() {
    this.element.classList.add('preventTurboScroll');
  }
  submit(e) {
    const handler = () => {
      window.Turbo.navigator.currentVisit.scrolled = true;

      document.removeEventListener('turbo:render', handler);
    };

    document.addEventListener('turbo:render', handler);

    this.element.requestSubmit(e.submitter);
  }
}
